module.exports = __webpack_public_path__ + "img/antonio-torre.0b34da91.svg";